{
  "luggage": {
    "unit_KG": "кг",
    "unit_PC": "шт"
  }
}
